import React, { useState, useContext } from 'react';
import { FaUserPlus, FaEyeSlash } from 'react-icons/fa';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import logo from '../../images/logo.png';
import { motion } from 'framer-motion';
// import zxcvbn from 'zxcvbn';
import { AuthContext } from '../AuthContext';
import { showSwalNotification } from '../../utils/SwalResponse';
// import { ReportContext } from '../../reports/ReportContext';
import { evaluatePasswordStrength } from '../../utils/passwords';
// import { EventsContext } from '../../events/EventsContext';
import GoogleLoginButton from './GoogleLoginButton';
import MyWebsite from '../../utils/MyWebsite';

const forestGreen = '#228B22';

const Register = () => {
  const {userRegistration} = useContext(AuthContext)
  // const {createBooking} = useContext(EventsContext)
  // const {} = useContext(ReportContext)
  const navigate = useNavigate()

  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const report = queryParams.get('rep'); 
  const eventId = queryParams.get('event_id');
  const issueId = queryParams.get('issue_id');

  const [formData, setFormData] = useState({
    name: '',
    email: '',
    password: '',
    confirmPassword: '',
    role: 'user',
    website:''
  });

  const [message, setMessage] = useState('');
  const [passwordError, setPasswordError] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirm, setShowConfirm] = useState(false);

  const passwordStrength = evaluatePasswordStrength(formData.password); // zxcvbn score: 0-4 → convert to 0-100%

  const getStrengthColor = (score) => {
    if (score < 40) return '#dc3545';       // red
    if (score < 60) return '#fd7e14';       // orange
    if (score < 80) return '#ffc107';       // yellow
    return '#28a745';                       // green
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));

    if (name === 'confirmPassword' || name === 'password') {
      setPasswordError(
        name === 'confirmPassword' || formData.confirmPassword
          ? value !== formData.password && formData.confirmPassword !== ''
            ? 'Passwords do not match'
            : ''
          : ''
      );
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (formData?.website) {
          setMessage('Bot-like behavior detected.');
          return;
        }
    if (formData.password !== formData.confirmPassword) {
      setPasswordError('Passwords do not match');
      return;
    }

      const { confirmPassword, ...submitData } = formData;
      // console.log(formData, submitData)
      const response = await userRegistration(submitData);
      showSwalNotification(response)
      if (response?.status === 'success'){      
        if (!!report){
          if (report === 'submit') {
            navigate('/report');
            return;
          } else if (report === 'reg_event'&& eventId) {
            await navigate(`/events/${eventId}`);
            // const response = await createBooking(eventId);
            // showSwalNotification(response);
            return;
          }else if (report === 'attend' && eventId){
              await navigate(`/events/${eventId}/attendance`)
              return;
            }else if (report === 'attend' && eventId){
              await navigate(`/events/${eventId}/attendance`)
              return;
            }else if (report === 'review' && issueId) {
              await navigate(`/reviews/add/${issueId}`);
              return;
            }
        }  
        navigate('/dashboard') 
      }else{
        setMessage(response?.message)
      }
    
  };


  return (
    <motion.div
      className="d-flex p-3 bg-none justify-content-center align-items-center "
      // style={{ background: '#f8f9fa'}}
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
    >
      <motion.div
        className="card p-4 my-3 shadow-lg"
        style={{
          width: '100%',
          maxWidth: '480px',
          minHeight: 'fit-content',
          borderRadius: '16px',
          border: `1px solid ${forestGreen}`,
          backgroundColor: 'rgb(255,255,255,0.5',
        }}
        initial={{ y: 30, scale: 0.98 }}
        animate={{ y: 0, scale: 1 }}
        transition={{ duration: 0.4 }}
      >
        {/* Logo */}
        <div className="text-center mb-3">
          <img src={logo} alt="App Logo" style={{ width: '90px', height: 'auto' }} />
        </div>

        <h3 className="text-center mb-4" style={{ color: forestGreen, fontWeight: '600' }}>
          <FaUserPlus className="mb-1" /> Create Account
        </h3>

        {message && <div className="alert alert-info text-center">{message}</div>}

        <form onSubmit={handleSubmit}>
          <MyWebsite onChange={handleChange} />
          {/* Name */}
          <motion.div className="form-group mb-3" whileFocus={{ scale: 1.02 }}>
            <label style={{ fontWeight: 500, color: '#333' }}>👤 Name</label>
            <input
              type="text"
              name="name"
              className="form-control"
              value={formData.name}
              onChange={handleChange}
              required
              style={{ borderColor: forestGreen }}
            />
          </motion.div>

          {/* Email */}
          <motion.div className="form-group mb-3" whileFocus={{ scale: 1.02 }}>
            <label style={{ fontWeight: 500, color: '#333' }}>✉️ Email</label>
            <input
              type="email"
              name="email"
              className="form-control"
              value={formData.email}
              onChange={handleChange}
              required
              style={{ borderColor: forestGreen }}
            />
          </motion.div>

          {/* Password */}
          <motion.div className="form-group mb-3" whileFocus={{ scale: 1.02 }}>
            <label style={{ fontWeight: 500, color: '#333' }}>🔒 Password</label>
            <div className="input-group">
              <input
                type={showPassword ? 'text' : 'password'}
                name="password"
                className="form-control"
                value={formData.password}
                onChange={handleChange}
                required
                style={{ borderColor: forestGreen }}
              />
              <span className="input-group-text" onClick={() => setShowPassword(!showPassword)} style={{ cursor: 'pointer' }}>
                {showPassword ? <FaEyeSlash /> : '👁️'}
              </span>
            </div>

            {/* Password Strength Bar */}
            {!!formData?.password && (<div className="mt-2">
              <div className="progress" style={{ height: '8px' }}>
                <div
                  className="progress-bar"
                  role="progressbar"
                  style={{
                    width: `${passwordStrength}%`,
                    backgroundColor: getStrengthColor(passwordStrength),
                  }}
                ></div>
              </div>
              <small className="text-muted">Password strength: {passwordStrength}%</small>
            </div>
          )}
          </motion.div>

          {/* Confirm Password */}
          <motion.div className="form-group mb-3" whileFocus={{ scale: 1.02 }}>
            <label style={{ fontWeight: 500, color: '#333' }}>🔒 Confirm Password</label>
            <div className="input-group">
              <input
                type={showConfirm ? 'text' : 'password'}
                name="confirmPassword"
                className="form-control"
                value={formData.confirmPassword}
                onChange={handleChange}
                required
                style={{ borderColor: forestGreen }}
              />
              <span className="input-group-text" onClick={() => setShowConfirm(!showConfirm)} style={{ cursor: 'pointer' }}>
                {showConfirm ? <FaEyeSlash /> : '👁️'}
              </span>
            </div>
            {passwordError && <small className="text-danger">{passwordError}</small>}
          </motion.div>

          {/* Submit */}
          <motion.button
            type="submit"
            className="btn w-100 mt-3"
            style={{
              backgroundColor: forestGreen,
              color: '#fff',
              fontWeight: 600,
              letterSpacing: 0.5,
              borderRadius: '8px',
            }}
            whileHover={{ scale: 1.02 }}
            whileTap={{ scale: 0.98 }}
            disabled={!!passwordError || passwordStrength < 80}
          >
            <FaUserPlus className="me-2" />
            Register
          </motion.button>
        </form>

        {/* Login Link */}
        <div className="text-center mt-3">
          <small>
            Already have an account?{' '}
            <Link to={`/login${
              report
                ? `?${[
                  report ? `rep=${encodeURIComponent(report)}` : '',
                  eventId ? `event_id=${encodeURIComponent(eventId)}` : '',
                  issueId ? `issue_id=${encodeURIComponent(issueId)}` : '',
                ]
                  .filter(Boolean)
                  .join('&')}`
                : ''
              }`} style={{ color: forestGreen, fontWeight: 500 }}>
              Login here
            </Link>
          </small>
        </div>

        <hr className="my-4" />

        {/* Google Register */}
        <GoogleLoginButton/>
      </motion.div>
    </motion.div>
  );
};

export default Register;
